import { render, staticRenderFns } from "./AirwallexPayment.vue?vue&type=template&id=046bcb8e&scoped=true"
import script from "./AirwallexPayment.vue?vue&type=script&lang=js"
export * from "./AirwallexPayment.vue?vue&type=script&lang=js"
import style0 from "./AirwallexPayment.vue?vue&type=style&index=0&id=046bcb8e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "046bcb8e",
  null
  
)

export default component.exports